import { useState } from "react";
import { IoIosArrowUp as ArrowUpIcon } from "react-icons/io";
import { Link } from "react-router-dom";
import { ReactComponent as ListItemArrow } from "./Assets/item-arrow.svg";

import "./TeamCard.style.scss";

const TeamCard = ({
  image,
  backgroundGradient,
  name,
  profession,
  logo,
  userAvatar,
  socialMediaLinks,
  testimonial,
  experience,
  about,
  siteUrl,
  experienceTitle,
}) => {
  const [detailsExpanded, setDetailsExpanded] = useState(false);

  return (
    <>
      <div
        className="team-card "
        style={{
          "--cardImg": `url(${image})`,
        }}
      >
        <div
          className={`details-container ${detailsExpanded ? "expanded" : ""}`}
          style={{
            "--backgroundGradient": backgroundGradient,
          }}
        >
          <button
            className="expand-btn"
            onClick={() => setDetailsExpanded(!detailsExpanded)}
          >
            <ArrowUpIcon
              className={`expand-icon ${detailsExpanded ? "rotate" : ""}`}
            />
          </button>

          <div className="small-container" aria-hidden={detailsExpanded}>
            <div>
              <div className="title-container d-flex justify-content-center mt-4">
                <h4 className="font-pnsb font-size-32">To be announced</h4>
                {/* <h4 className="mb-0 font-pnsb">{name}</h4>

                {profession ? (
                  <h6 className="mb-0 font-pnm font-size-24">{profession}</h6>
                ) : null} */}
              </div>
              {/* <div className="badges-container">
                <img src={logo} className="logo" alt="logo" />
                <div className="badge font-size-18 font-pnm">
                  <Link
                    to={`${
                      siteUrl ? `https://${siteUrl}` : "https://rhuna.io"
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {siteUrl ? trimString(siteUrl, 21) : "rhuna.io"}
                  </Link>
                </div>
              </div> */}
            </div>
          </div>

          <div className="expanded-container" aria-hidden={detailsExpanded}>
            <div>
              <div className="scrollable">
                <div className="identity-container align-items-center">
                  <img src={userAvatar} className="avatar-img" alt="avatar" />
                  <div>
                    <h5 className="font-pnsb">{name}</h5>
                    <h6 className="font-pnm">{profession}</h6>
                  </div>
                </div>

                {socialMediaLinks ? (
                  <div className="social-media-links-container">
                    {socialMediaLinks?.map(({ icon, link }, index) => (
                      <Link key={index} to={link}>
                        {icon}
                      </Link>
                    ))}
                  </div>
                ) : null}
                {/* <hr className="separator-line" /> */}
                {testimonial !== "" ? (
                  <p className="mb-2 testimonial font-pnm">{testimonial}</p>
                ) : null}
                {/* <hr className="separator-line" /> */}
                {experience ? (
                  <>
                    {" "}
                    <h6 className="experience font-pnsb">
                      {experienceTitle ?? "Experience"}
                    </h6>
                    <div className="experience-container font-pnr">
                      {experience?.map((listItem, index) => (
                        <div key={index} className="experience-item">
                          <ListItemArrow />
                          {listItem}
                        </div>
                      ))}
                    </div>{" "}
                  </>
                ) : null}
                <h6 className="about font-pnsb">About</h6>
                <div className="about-container font-pnr">
                  {about?.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamCard;
